module.exports = __webpack_public_path__ + "img/lives.6d4f712d.gif";